<template>
  <Patch>
    <h5 slot="title">資料匯入</h5>

  </Patch>
</template>

<script>
import Patch from '../common/AdminPatch';

export default {
  name: 'ADCManagement',
  components: {
    Patch,
  },
};
</script>



// WEBPACK FOOTER //
// DataImport.vue?425516c8